import { DeltaPill } from '@/components/ads/DeltaPill';
import { SoftCard } from '@/components/ui/soft-card';

/**
 * Centred big-number KPI used in the per-channel performance grids. Wraps a
 * SoftCard with a fixed three-row layout so adjacent tiles align even when
 * one of them has no delta. `delta` is a numeric percentage (passed straight
 * to DeltaPill) — pass `sub` as a string for a neutral helper line instead.
 */
export function KpiTile({ label, value, sub, delta }) {
	return (
		<SoftCard className="grid min-h-[170px] grid-rows-[auto_1fr_auto] px-5 pb-5 pt-4 text-center md:px-6">
			<div className="flex h-10 items-start justify-center text-center text-xs font-semibold uppercase leading-[1.25rem] tracking-wider text-muted-foreground">
				{label}
			</div>
			<div className="flex items-center justify-center text-3xl font-extrabold tracking-tight md:text-4xl">{value}</div>
			<div className="flex h-10 items-end justify-center">
				{delta !== undefined && delta !== null ? (
					<DeltaPill value={delta} />
				) : (
					<span className="text-xs text-muted-foreground">{sub}</span>
				)}
			</div>
		</SoftCard>
	);
}
